export default function (code) {
  return code && code.trim().length === 6
}
